// extracted by mini-css-extract-plugin
export default {"name":"info_name__OHIQD","fields":"info_fields__LKguH","field":"info_field__hXj0A","buttons":"info_buttons__AjALu","buttonChange":"info_buttonChange__VkVVs"};